/**
 * Progress — a sheet browser.
 *
 * The cards are the papers this student has sat, newest first, each with its
 * percentage and its five-band ramp, so the run of cards is the trend a line
 * chart would draw — except every point on it opens. Picking one renders that
 * paper's mastery sheet underneath. Everything here is `StudentProgress`,
 * which the teacher's one-student view also renders: a teacher at a PTM has to
 * be looking at the page the child is looking at.
 */
import { useMemo } from 'react';
import { decodeClaims, boardGradeLabel } from '@/lib/auth';
import { StudentPage, StudentPageHeader } from '@/components/ds';
import { StudentProgress } from '@/components/reports/StudentProgress';

export function ProgressDashboardPage() {
  const claims = useMemo(() => decodeClaims(), []);
  const sid = claims?.sub ?? '';

  return (
    <StudentPage className="gap-4">
      <StudentPageHeader
        title="My progress"
        subtitle={boardGradeLabel(claims)}
        action={
          <button
            type="button"
            onClick={() => window.print()}
            className="rounded-full px-3.5 py-2 text-xs font-bold transition"
            style={{ background: 'var(--paper-sunk)', color: 'var(--ink-2)' }}
          >
            Print sheet
          </button>
        }
      />

      <StudentProgress studentId={sid} />
    </StudentPage>
  );
}
